import React from "react";
import Logo from "../../../containers/assets/LandingPageLogo3.png";

function TeamReportsOneColumnLayout({ title = "", content = "" }) {
  return (
    <div className="team-reports-layout team-reports-one-column">
      <div className="team-reports-logo without-border">
        <img src={Logo} alt="logo" />
        <div className="orange-line" />
        <div className="green-line" />
      </div>
      <div className="title">{title}</div>
      <div className="one-column-inner-content">{content}</div>
    </div>
  );
}

export default TeamReportsOneColumnLayout;



// WEBPACK FOOTER //
// ./src/components/team-reports/layouts/one-column.js